export class ProductFormVariantSelect {
    constructor(product_json, section_id, enable_history) {
        this.product_json = product_json;
        this.product_id = this.product_json.id;
        this.section_id = section_id;
        // this.enable_history = enable_history;
        this.enable_history = false;
        this.stock_rules = {};
        this.master_select = null;
        this.product_form = null;
        this.quantity_selector = null;
        this.master_select_prefix = "product-id";
        this.radio = ".option-radios-wrapper input[type=radio]";
        this.form = "form[action='/cart/add']";
        this.option_selector = ".selector-wrapper select";

        this.init();
    }

    init() {
        this.master_select = document.querySelector(
            "#" +
            this.master_select_prefix +
            "-" +
            this.section_id +
            "-" +
            this.product_id
        );
        this.product_form = this.master_select.closest(this.form);
        this.quantity_selector =
            this.product_form.querySelector("[quantity-select]");
        this.subtotal_el = this.product_form.querySelector("[product-sub-total]");
        this.maxtotal_el = this.product_form.querySelector("[product-max-total]");
        this.savingtotal_el = this.product_form.querySelector(
            "[product-saving-total]"
        );
        this.add_to_cart = this.product_form.querySelector("[add-to-cart]");
        this.gallery_slides = document.querySelectorAll(
            "[main-gallery] .main-swiper-slide"
        );
        this.text_add_to_cart = this.product_form.dataset.addToCart;
        this.text_sold_out = this.product_form.dataset.soldOut;
        this.text_unavailable = this.product_form.dataset.unavailable;
        this.money_format = this.product_form.dataset.moneyFormat;

        // Get metafield option names
        this.option_name_1 = this.product_form.dataset.optionNameOne;
        this.option_name_2 = this.product_form.dataset.optionNameTwo;
        this.option_name_3 = this.product_form.dataset.optionNameThree;

        this.stockRules();
        this.shopifyOptionSelect();
        this.radiosOnChange();
        this.initCustomSelect();
        this.selectChange();
    }

    stockRules() {
        const select_options = this.master_select.querySelectorAll("option");
        if (select_options.length === 0) {
            console.error("Select options not found.");
            return;
        }
        select_options.forEach((option) => {
            if (
                option.dataset.inventoryManagement === "shopify" &&
                option.dataset.inventoryPolicy === "deny"
            ) {
                this.stock_rules[option.value] = option.dataset.inventoryQuantity;
            } else {
                this.stock_rules[option.value] = Number.MAX_SAFE_INTEGER;
            }
        });
    }

    setVariantPrice(variant) {
        if (!this.subtotal_el) {
            return;
        }
        const money_format = this.subtotal_el.dataset.moneyFormat;
        this.subtotal_el.setAttribute("data-variant-price", variant.price);
        this.subtotal_el.innerHTML = Shopify.formatMoney(
            variant.price,
            money_format
        );
    }

    setSubmitButtonState(availability) {
        const submit = this.add_to_cart;
        const ADD_TO_CART = this.text_add_to_cart;
        const SOLD_OUT = this.text_sold_out;
        const UNAVAILABLE = this.text_unavailable;
        if (!submit) {
            console.error("Submit button not found.");
            return;
        }
        if (availability === true || availability === "true") {
            submit.value = ADD_TO_CART;
            submit.innerHTML = ADD_TO_CART;
            submit.removeAttribute("disabled");
        } else if (availability === "unavailable") {
            submit.value = UNAVAILABLE;
            submit.innerHTML = UNAVAILABLE;
            submit.setAttribute("disabled", "");
        } else {
            submit.value = SOLD_OUT;
            submit.innerHTML = SOLD_OUT;
            submit.setAttribute("disabled", "");
        }
    }

    setQuantityVisibility(availability) {
        if (!this.quantity_selector) {
            return;
        }
        const quantity_wrapper =
            this.quantity_selector.closest(".quantity-wrapper");
        if (!quantity_wrapper) {
            return;
        }

        if (availability === "unavailable" || availability === false) {
            quantity_wrapper.style.display = "none";
        } else {
            quantity_wrapper.style.display = "flex";
        }
    }

    setQuantityStock(variant) {
        if (!this.quantity_selector) {
            return;
        }
        const quantity_input = this.quantity_selector.querySelector("input");
        if (!quantity_input) {
            console.error("Quantity input not found.");
            return;
        }

        const max_stock = this.stock_rules[variant.id];
        quantity_input.max = max_stock;
    }

    setQuantityRules(quantity_rule) {
        if (!this.quantity_selector) {
            return;
        }
        const quantity_input = this.quantity_selector.querySelector("input");
        if (!quantity_input) {
            console.error("Quantity input not found.");
            return;
        }

        const quantity_number_el =
            this.quantity_selector.querySelector("[quantity]");
        if (!quantity_number_el) {
            console.error("Quantity number element not found.");
            return;
        }

        if (quantity_rule.min) {
            quantity_input.min =
                quantity_input.value =
                quantity_number_el.innerHTML =
                quantity_rule.min;
        } else {
            quantity_input.min =
                quantity_input.value =
                quantity_number_el.innerHTML =
                1;
        }
        if (quantity_rule.max) {
            quantity_input.max = quantity_rule.max;
        }
        if (quantity_rule.step) {
            quantity_input.step = quantity_rule.step;
        }
    }

    checkRadios(selector) {
        const selects = selector.selectors;
        const radios = this.product_form.querySelectorAll(this.radio);
        if (radios.length > 0) {
            selects.forEach((select) => {
                const select_index = select.index + 1;
                const selected_option_index = select.element.selectedIndex;
                const radio_to_check = this.product_form.querySelector(
                    `.radio-option[data-option="${select_index}"] input[data-index="${selected_option_index}"]`
                );
                if (radio_to_check) {
                    radio_to_check.checked = true;
                    radio_to_check.setAttribute("checked", true);
                } else {
                    console.log(`Radio button for select ${select_index} not found.`);
                }
            });
        }
    }

    findCheckedRadio() {
        const radios = this.product_form.querySelectorAll(this.radio);

        if (radios.length > 0) {
            radios.forEach((radio) => {
                if (radio.checked) {
                    console.log("Radio checked: ", radio);
                    radio.click();
                    this.setOOSSelects(radio.value);
                }
            });
        } else {
            // const first_select = this.product_form.querySelector(this.option_selector + '[data-option="option1"]');
            // this.setSelectAvailability("option1", first_select.value);
        }
    }

    radiosOnChange() {
        const radios = this.product_form.querySelectorAll(this.radio);
        const selects = this.product_form.querySelectorAll(this.option_selector);

        if (radios.length > 0) {
            radios.forEach((radio) => {
                radio.addEventListener("change", () => {
                    const option_index = radio.closest(".radio-option").dataset.option;
                    const option_value = radio.value;
                    const select = this.product_form.querySelector(
                        `select[data-option='option${option_index}']`
                    );
                    if (select) {
                        select.value = option_value;
                        // trigger change event
                        const event = new Event("change");
                        select.dispatchEvent(event);
                        this.setOOSSelects(option_value); // Update availability
                        this.initCustomSelect();
                    } else {
                        console.error(
                            `Select element for radio ${option_index} not found.`
                        );
                    }
                });
            });
        }

        // if (selects.length > 0) {
        //     selects.forEach((select) => {
        //         select.addEventListener("change", () => {
        //             const option_index = select.dataset.option;
        //             const option_value = select.value;

        //             const masterSelect = this.product_form.querySelector(
        //                 `select[data-option='${option_index}']`
        //             );
        //             if (masterSelect) {
        //                 masterSelect.value = option_value;
        //                 // trigger change event
        //                 const event = new Event("change");
        //                 masterSelect.dispatchEvent(event);
        //                 this.setOOSSelects(option_value); // Update availability
        //                 this.initCustomSelect();
        //             } else {
        //                 console.error(
        //                     `Select element for select ${option_index} not found.`
        //                 );
        //             }
        //         });
        //     });
        // }
    }

    selectChange() {
        const selects = this.product_form.querySelectorAll(this.option_selector);
        if (selects.length === 0) {
            console.error("Select elements not found.");
            return;
        }
        selects.forEach((select) => {
            select.addEventListener("change", () => {
                const selected_option = select.value;
                const index = select.dataset.option;
                // this.setSelectAvailability(index, selected_option);
            });
        });
    }

    setSelectAvailability(select_index, value) {
        console.log("Select index: ", select_index);
        console.log("Value: ", value);

        const formOptions = this.product_form.querySelectorAll(this.option_selector + " option");

        formOptions.forEach((option) => {
            option.classList.remove("unavailable");
        });

        if (select_index == "option1") {
            const selected_option_1 = this.product_form.querySelector(this.option_selector + "[data-option='option1']");
            console.log("🚀 ~ ProductFormVariantSelect ~ setSelectAvailability ~ selected_option_1:", selected_option_1);
            // trigger change event
            const event = new Event("change");
            selected_option_1.dispatchEvent(event);
            // const availableOptions = this.master_select.querySelectorAll(`option[data-option1="${value}"]`);
            // availableOptions.forEach((master_option) => {
            //     const isOptionAvailable = master_option.dataset.availability;
            //     if (isOptionAvailable == "false") {
            //         const option_2 = this.product_form.querySelector(this.option_selector + "[data-option='option2'] option[value='" + master_option.dataset.option2 + "']");
            //         const option_3 = this.product_form.querySelector(this.option_selector + "[data-option='option3'] option[value='" + master_option.dataset.option3 + "']");
            //         if (option_2) {
            //             option_2.classList.add("unavailable");
            //         }
            //         if (option_3) {
            //             option_3.classList.add("unavailable");
            //         }
            //         if (option_2 || option_3) {
            //             this.initCustomSelect();
            //         }
            //     }
            // });
        } else if (select_index == "option2") {

            const selected_option_1 = this.product_form.querySelector(this.option_selector + "[data-option='option1']");
            console.log("🚀 ~ ProductFormVariantSelect ~ setSelectAvailability ~ selected_option_1:", selected_option_1);
            // trigger change event
            const event = new Event("change");
            selected_option_1.dispatchEvent(event);

            // const availableOptions = this.master_select.querySelectorAll(`option[data-option2="${value}"]`);
            // availableOptions.forEach((master_option) => {
            //     const isOptionAvailable = master_option.dataset.availability;
            //     if (isOptionAvailable == "false") {
            //         const option_1 = this.product_form.querySelector(this.option_selector + "[data-option='option1'] option[value='" + master_option.dataset.option1 + "']");
            //         const option_3 = this.product_form.querySelector(this.option_selector + "[data-option='option3'] option[value='" + master_option.dataset.option3 + "']");
            //         if (option_1) {
            //             option_1.classList.add("unavailable");
            //         }
            //         if (option_3) {
            //             option_3.classList.add("unavailable");
            //         }
            //         if (option_1 || option_3) {
            //             this.initCustomSelect();
            //         }
            //     }
            // });
        } else if (select_index == "option3") {
            const selected_option_1 = this.product_form.querySelector(this.option_selector + "[data-option='option1']");
            console.log("🚀 ~ ProductFormVariantSelect ~ setSelectAvailability ~ selected_option_1:", selected_option_1);
            // trigger change event
            const event = new Event("change");
            selected_option_1.dispatchEvent(event);
            // const availableOptions = this.master_select.querySelectorAll(`option[data-option3="${value}"]`);
            // availableOptions.forEach((master_option) => {
            //     const isOptionAvailable = master_option.dataset.availability;
            //     if (isOptionAvailable == "false") {
            //         const option_1 = this.product_form.querySelector(this.option_selector + "[data-option='option1'] option[value='" + master_option.dataset.option1 + "']");
            //         const option_2 = this.product_form.querySelector(this.option_selector + "[data-option='option2'] option[value='" + master_option.dataset.option2 + "']");
            //         if (option_1) {
            //             option_1.classList.add("unavailable");
            //         }
            //         if (option_2) {
            //             option_2.classList.add("unavailable");
            //         }
            //         if (option_1 || option_2) {
            //             this.initCustomSelect();
            //         }
            //     }
            // });
        } else {
            console.error("Select index not found.");
            return;
        }
    }

    setOOSSelects(value) {
        console.log("Value: ", value);
        const availableOptions = this.master_select.querySelectorAll(
            `option[data-option1="${value}"]`
        );
        const formOptions = this.product_form.querySelectorAll(
            this.option_selector + " option"
        );

        formOptions.forEach((option) => {
            option.classList.remove("unavailable");
        });

        if (availableOptions.length > 0) {
            const option2Availability = {};
            const option3Availability = {};

            availableOptions.forEach((option) => {
                const isOptionAvailable = option.dataset.availability === "true";
                let option2Value = option.dataset.option2;
                let option3Value = option.dataset.option3;

                // option2Value = option2Value.replace(/&quot;/g, '').replace(/"/g, '');
                // option3Value = option3Value.replace(/&quot;/g, '').replace(/"/g, '');

                // Track availability for option2
                if (!option2Availability[option2Value]) {
                    option2Availability[option2Value] = false;
                }
                if (isOptionAvailable) {
                    option2Availability[option2Value] = true;
                }

                // Track availability for option3
                if (!option3Availability[option3Value]) {
                    option3Availability[option3Value] = false;
                }
                if (isOptionAvailable) {
                    option3Availability[option3Value] = true;
                }
            });

            // Update option2 based on tracked availability
            Object.keys(option2Availability).forEach((option2Value) => {
                const option2Select = this.product_form.querySelector(
                    `${this.option_selector}[data-option="option2"] option[value='${option2Value}']`
                );
                if (option2Select) {
                    option2Select.classList.toggle("unavailable", !option2Availability[option2Value]);
                }
            });

            // Update option3 based on tracked availability
            Object.keys(option3Availability).forEach((option3Value) => {
                const option3Select = this.product_form.querySelector(
                    `${this.option_selector}[data-option="option3"] option[value='${option3Value}']`
                );
                if (option3Select) {
                    option3Select.classList.toggle("unavailable", !option3Availability[option3Value]);
                }
            });
        } else {
            // Grey out all options if no available options are found
            formOptions.forEach((option) => {
                option.classList.add("unavailable");
            });
        }
    }

    variantImageChange(variant) {
        if (!this.gallery_slides) {
            return;
        }
        // Loop through all gallery slides and get comma separate list of idfs from image slide - data-id
        this.gallery_slides.forEach((slide) => {
            const slide_id = slide.dataset.id;
            const slide_index = slide.dataset.index;

            if (!slide_id) {
                console.error("Slide id not found.");
                return;
            }
            const slide_variant_ids = slide_id.split(",");
            // If variant id is in slide_variant_ids, show slide
            if (slide_variant_ids.includes(variant.id.toString())) {
                mainSwiper.slideTo(slide_index, 500);
            }
        });
    }

    selectCallback(variant, selector) {
        // AVAILABILITY STATES
        const AVAILABILITY_AVAILABLE = true;
        const AVAILABILITY_UNAVAILABLE = "unavailable";
        const AVAILABILITY_SOLD_OUT = "sold_out";

        // const options = this.product_form.querySelectorAll(
        //     this.option_selector + " option"
        // );
        // options.forEach((option) => {
        //     if (option.selected) {
        //         option.innerHTML = option.innerHTML.replace(
        //             " - " + this.text_unavailable,
        //             ""
        //         );
        //         option.classList.remove("unavailable");
        //     }
        // });

        // SUBMIT BUTTON STATE - Changes submit button text and state based on variant availability
        if (!variant) {
            this.setSubmitButtonState(AVAILABILITY_UNAVAILABLE);
            this.setQuantityVisibility(AVAILABILITY_UNAVAILABLE);
            // const option_selects = this.product_form.querySelectorAll(
            //     this.option_selector
            // );
            // option_selects.forEach((select) => {
            //     console.log("Select: ", select.value);
            //     const select_value = select.value;
            //     const options = select.querySelectorAll("option");
            //     options.forEach((option) => {
            //         if (option.value === select_value) {
            //             option.innerHTML = option.innerHTML + " - " + this.text_unavailable;
            //         }
            //     });
            // });
            return;
        }

        if (variant.available) {
            this.setSubmitButtonState(AVAILABILITY_AVAILABLE);
            this.setQuantityVisibility(AVAILABILITY_AVAILABLE);
        } else {
            this.setSubmitButtonState(AVAILABILITY_SOLD_OUT);
            this.setQuantityVisibility(AVAILABILITY_SOLD_OUT);
        }

        // CHECK RADIOS - checks radio buttons based on option select element
        this.checkRadios(selector);
        // QUANTITY RULES IF PRESENT - Adds min and max attributes to quantity input
        this.setQuantityStock(variant);
        // SET PRICE - Sets price based on variant
        this.setQuantityRules(variant.quantity_rule);
        // SET STOCK - Sets max stock attribute to quantity input
        this.setVariantPrice(variant);
        // SET IMAGE - Changes main image based on variant
        // this.variantImageChange(variant);
        // FIND CHECKED RADIO - Finds checked radio button and sets OOS selects
        console.log("VARIANT: ", variant);
        this.findCheckedRadio();
    }

    shopifyOptionSelect() {
        new Shopify.OptionSelectors(
            this.master_select_prefix + "-" + this.section_id + "-" + this.product_id,
            {
                product: this.product_json,
                onVariantSelected: this.selectCallback.bind(this),
                enableHistoryState: this.enable_history,
            }
        );
    }

    initCustomSelect() {
        const wrapperElements = this.product_form.querySelectorAll("div:not(.product-card-container) .selector-wrapper");
        const chevron_down = document.createElement("DIV");
        chevron_down.setAttribute("class", "chevron-down");
        chevron_down.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z"/></svg>';

        Array.from(wrapperElements).forEach((wrapperElement,i) => {
            const selectElement = wrapperElement.querySelector("select");
            if (!selectElement) {
                return;
            }

            const numOptions = selectElement.length;

            let selectedOptionName, selectedItem, optionsContainer;

            if (wrapperElement.querySelector(".select-selected")) {
                selectedItem = wrapperElement.querySelector(".select-selected");
                // selectedItem.setAttribute("data-chevron", "&#8250;");
                optionsContainer = wrapperElement.querySelector(".select-items");
            } else {
                const selectContainer = document.createElement("DIV");
                selectContainer.setAttribute("class", "select-selected-container");

                wrapperElement.appendChild(selectContainer);
                selectedOptionName = document.createElement("DIV");
                selectedOptionName.setAttribute("class", "select-name");
                if (i === 0) {
                    selectedOptionName.innerHTML = this.option_name_1 + ":";
                } else if (i === 1) {
                    selectedOptionName.innerHTML = this.option_name_2 + ":";
                } else if (i === 2) {
                    selectedOptionName.innerHTML = this.option_name_3 + ":";
                }

                selectContainer.appendChild(selectedOptionName);

                selectedItem = document.createElement("DIV");
                selectedItem.setAttribute("class", "select-selected");
                // selectedItem.setAttribute("data-chevron", "&#8250;");
                selectedItem.innerHTML = selectElement.options[selectElement.selectedIndex].innerHTML;

                selectContainer.appendChild(selectedItem);

                optionsContainer = document.createElement("DIV");
                optionsContainer.setAttribute("class", "select-items select-hide");
                wrapperElement.appendChild(optionsContainer); // Ensure optionsContainer is appended to the wrapper

            }

            // Clear existing options
            optionsContainer.innerHTML = '';

            for (let j = 0; j < numOptions; j++) {  // Updated loop to start from 0 to include all options

                const optionItem = document.createElement("DIV");
                optionItem.innerHTML = selectElement.options[j].innerHTML;

                optionItem.addEventListener("click", function () {
                    const parentWrapper = this.parentNode.parentNode;
                    const parentSelect = parentWrapper.querySelector("select");
                    const numSelectOptions = parentSelect.length;
                    const previousSibling = this.parentNode.previousSibling;
                    const hiddenSelect = wrapperElement.querySelector("select");

                    for (let k = 0; k < numSelectOptions; k++) {

                        const regex = /^.*?\s-/;
                        const result = parentSelect.options[k].innerHTML.replace(regex, "");
                        const removeSpace = /^\s+/;
                        const finalResult = result.replace(removeSpace, "");

                        const inner = this.innerHTML;
                        const innerClean = inner.replace(regex, "");
                        const innerFinal = innerClean.replace(removeSpace, "");


                        if (finalResult === innerFinal) {
                            parentSelect.selectedIndex = k;
                            previousSibling.querySelector('.select-selected').innerHTML = innerFinal;

                            const option_value = parentSelect.options[k].value;

                            hiddenSelect.value = option_value;
                            const event = new Event("change");

                            hiddenSelect.dispatchEvent(event);

                            const selectOptionParent = this.parentNode;
                            if (selectOptionParent) {
                                const selectedOptions = selectOptionParent.getElementsByClassName("same-as-selected");
                                Array.from(selectedOptions).forEach(option => option.classList.remove("same-as-selected"));

                                this.setAttribute("class", "same-as-selected");

                                if (parentSelect.options[k].classList.contains("unavailable")) {
                                    this.classList.add("unavailable");
                                    previousSibling.querySelector('.select-selected').classList.add("unavailable");
                                } else {
                                    this.classList.remove("unavailable");
                                    previousSibling.querySelector('.select-selected').classList.remove("unavailable");
                                }
                            }

                            break;
                        }

                        if (parentSelect.options[k].classList.contains("unavailable")) {
                            this.classList.add("unavailable");
                            previousSibling.querySelector('.select-selected').classList.add("unavailable");
                        } else {
                            this.classList.remove("unavailable");
                            previousSibling.querySelector('.select-selected').classList.remove("unavailable");
                        }

                    }
                    const options = wrapperElement.querySelectorAll(".select-items div");
                    options.forEach((option) => {
                        option.classList.remove("same-as-selected");
                    });
                    this.classList.add("same-as-selected");

                    const selectItems = wrapperElement.querySelector(".select-items");
                    selectItems.classList.remove("select-hide");

                    previousSibling.click();
                });

                optionsContainer.appendChild(optionItem);
            }
            wrapperElement.appendChild(optionsContainer);

            setTimeout(() => {
                const selectedText = wrapperElement.querySelector(".select-selected").innerHTML;
                const parentSelect = wrapperElement.querySelector("select");

                for (let k = 0; k < parentSelect.options.length; k++) {
                    const optionItem = wrapperElement.lastChild.childNodes[k];

                    const regex = /^.*?\s-/;
                    const result = parentSelect.options[k].innerHTML.replace(regex, "");
                    const removeSpace = /^\s+/;
                    const finalResult = result.replace(removeSpace, "");

                    if (finalResult === selectedText) {
                        if (parentSelect.options[k].classList.contains("unavailable")) {
                            wrapperElement.querySelector(".select-selected").classList.add("unavailable");
                            optionItem.classList.add("unavailable");
                        } else {
                            wrapperElement.querySelector(".select-selected").classList.remove("unavailable");
                            optionItem.classList.remove("unavailable");
                        }
                    } else {
                        if (parentSelect.options[k].classList.contains("unavailable")) {
                            optionItem.classList.add("unavailable");
                        } else {
                            optionItem.classList.remove("unavailable");
                        }
                    }
                }
            }, 500);

            // Remove existing click event listeners to avoid duplicates
            const newSelectedItem = selectedItem.cloneNode(true);
            selectedItem.parentNode.replaceChild(newSelectedItem, selectedItem);

            newSelectedItem.addEventListener("click", function (event) {
                event.stopPropagation();
                closeAllSelects(this);
                optionsContainer.classList.toggle("select-hide");
            });
        });


        // Set size of selectContainer based on largest option - add as a data attribute to select-selected and styling in CSS
        const selectContainers = this.product_form.querySelectorAll(".select-selected-container");
        selectContainers.forEach((selectContainer) => {
            const options = selectContainer.nextElementSibling.querySelectorAll("div");

            let maxLength = 0;
            options.forEach((option) => {
                const optionLength = option.innerHTML.length;

                if (optionLength > maxLength) {
                    maxLength = optionLength;
                    selectContainer.querySelector('.select-selected').setAttribute("data-max-length", option.innerHTML);
                }
            });
        });

        function closeAllSelects() {
            const selectItems = document.getElementsByClassName("select-items");
            // const selectSelected = document.getElementsByClassName("select-selected");

            Array.from(selectItems).forEach((selectItem) => {
                selectItem.classList.add("select-hide");
            });
        }

        document.addEventListener('click', function (event) {
            const selectedItem = document.querySelector('.select-selected');
            // Adjust this selector as needed

            if (selectedItem && !selectedItem.contains(event.target)) {
                closeAllSelects(selectedItem);
            }
        });
    }

}
